import { render, staticRenderFns } from "./SequencialMealSkipping.vue?vue&type=template&id=f494ccee"
import script from "./SequencialMealSkipping.vue?vue&type=script&lang=js"
export * from "./SequencialMealSkipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports